import styled from "@emotion/styled";
import { PublicKey } from "@solana/web3.js";
import { STEP_MINT } from "@stepfinance/common";
import type { StepLiquidityPool } from "@stepfinance/liquidity";
import type { FC } from "react";
import { useEffect } from "react";

import { useLanguageContext } from "../../contexts/language/language";
import { useSwapContextState } from "../../contexts/swap";
import { InfoCard } from "../InfoCard/InfoCard";
import type { LiquidityAction } from "../Liquidity/Liquidity";
import { YourPools } from "./YourPools";

export type AddToLiquidityProps = {
  pool?: StepLiquidityPool;
  onPoolLiquidityAction?: (action: LiquidityAction, pool: StepLiquidityPool | undefined) => void;
};

export const AddToLiquidity: FC<AddToLiquidityProps> = ({ pool: selectedPool, onPoolLiquidityAction }) => {
  const { A, B } = useSwapContextState();

  const {
    currentLanguageData: {
      pages: {
        swapLP: { liquidityTab: text },
      },
    },
  } = useLanguageContext();

  useEffect(() => {
    if (selectedPool?.mints?.[0]) {
      const baseMintAddress = new PublicKey(selectedPool.mints[0]);

      if (!A.mintAddress.equals(baseMintAddress)) {
        A.setMint(baseMintAddress);
      }
    }
  }, [selectedPool?.mints, A]);

  useEffect(() => {
    if (A.mintAddress.equals(STEP_MINT)) {
      A.setMint(B.mintAddress);
    }
    if (!B.mintAddress.equals(STEP_MINT)) {
      B.setMint(STEP_MINT);
    }
  }, [A, B]);

  const activeInfoTitle = text.deprecationMessageTitle;
  const activeInfoMessage = [
    text.reasonBehindDecision,

    <a href="https://stepfinance.medium.com/step-update-8-747c16da1219" target="_blank" rel="noreferrer" key={2}>
      {" "}
      {text.readMoreHere}{" "}
    </a>,
    `\n\n ${text.removeYourLiquidity}`,
  ];
  return (
    <>
      <AddLiquidityContainer>
        <InfoCard title={activeInfoTitle} type={"info"}>
          <span style={{ whiteSpace: "pre-line" }}>{activeInfoMessage}</span>
        </InfoCard>
      </AddLiquidityContainer>
      <YourPools onPoolLiquidityAction={onPoolLiquidityAction} />
    </>
  );
};

const AddLiquidityContainer = styled.div`
  background-color: #141414;
  padding: 10px;
  border-radius: 0px 8px 8px 8px;

  .swap-inputs {
    margin-bottom: 30px;
  }
`;
